import { Brand, BrandKey } from '../data/enum/brand';

// The assistant button does not change between brands.
export const isGenericAssistantButton = (brandName: BrandKey) => !!Brand[brandName];
